import type { Ref } from 'vue';

/**
 * Helper that sets loading to true/false reliably.
 */
export default async function useLoading(loadingRef: Ref<boolean>, callable: () => Promise<void>) {
  loadingRef.value = true;
  try {
    await callable();
  } finally {
    loadingRef.value = false;
  }
}
